import verifiedByVisa from '../../../assets/img/payment/verified-by-visa.png';
import masterCardSecureCode from '../../../assets/img/payment/mastercard-securecode.png';
import americanExpressSafeKey from '../../../assets/img/payment/amx-safekey.png';
import paypal from '../../../assets/img/payment/paypal.png';
import visa from '../../../assets/img/payment/visa.png';
import cb from '../../../assets/img/payment/cb.svg';
import masterCard from '../../../assets/img/payment/mastercard.png';
import americanExpress from '../../../assets/img/payment/amx.svg';
import floa from '../../../assets/img/payment/floa.svg';
import sepa from '../../../assets/img/payment/sepa.png';

export default {
  title: 'Paiement',
  titleIndividual: 'Finalisez votre réservation',
  subtitleIndividualWithArrhes: 'Règlement des arrhes',
  titlePCD: 'Votre moyen de paiement',
  subtitle: 'Validez votre moyen de paiement',
  subtitleIndividualWithArrhesAlreadyPaid: '✅ VOS ARRHES SONT DÉJÀ PRIS EN COMPTE',
  subtitleViewPayment: 'SÉLECTIONNEZ VOTRE MOYEN DE PAIEMENT',
  content: 'Choisissez le moyen de paiement que vous souhaitez utiliser pour régler le montant de {price}.',
  paymentTypes: {
    title: 'Informations sur le paiement',
  },
  cardPayment: {
    placeholder: {
      name: 'Nom affiché sur la carte',
      number: 'Numéro de la carte',
      expiry: 'Expire le',
      cvc: 'CVC',
    },
  },
  preBooking: {
    title: 'Pré-réservation',
    subtitleIndividual: 'Sélectionner votre moyen de paiement',
    subtitleIndividualWithArrhesAlreadyPaid: 'Vos arrhes sont déjà pris en compte',
    loadingText: 'Pré-réservation de votre déménagement en cours',
    loadingTitle: 'Validation de votre carte bancaire',
    infoStep: {
      content: '<b>ÉTAPE {currentStep}/{totalSteps}</b><br><b>Cette étape permet de valider la disponibilité de votre déménageur</b> aux dates souhaitées pour votre déménagement',
    },
    paymentTypes: {
      title: '@:payment.paymentTypes.title',
      creditCard: {
        options: {
          title: 'Carte bancaire',
          contentIndividualWithArrhes: `<p>Entrez votre carte bancaire dès maintenant, le paiement n'interviendra qu'à la réservation finale.</p><p><b>Vous ne serez débité des arrhes qu'après confirmation de la disponibilité du déménageur et signature de votre contrat.</b></p><p>Le paiement de votre déménagement s'effectue en 2 étapes :</p><ul><li>Les arrhes, prélevées lors de la signature de votre contrat</li>(représentant 30 % du montant total)<li>Le solde, prélevé une fois votre déménagement effectué</li></ul><p>NB : Vous ne signerez votre contrat qu'une fois que le déménageur de votre choix aura validé sa disponibilité.</p>`,
          contentIndividualWithArrhesAlreadyPaid: 'Les arrhes de {arrhesPercent} % (montant : {arrhesAmount} {exclTax}) que vous avez réglés lors de votre première réservation ont bien été préservés.<br><ul><li><b>Aucun nouveau paiement n\'est nécessaire aujourd\'hui.</b></li><li><b>Les arrhes déjà versés seront déduits du montant total de votre déménagement.</b></li><li><b>Lors du paiment final, vous réglerez uniquement le solde restant.</b></li></ul>',
        },
      },
      installment: {
        options: {
          title: '4 x par carte bancaire',
          content: `
          <p>Payez en plusieurs fois grâce à notre partenaire Floa</p>
          <p>Votre demande est validée instantanément après saisie de vos informations bancaires.</p>
          <p>À ce stade, aucun débit n'est effectué :</p>
          <ul>
            <li>Le premier prélèvement aura lieu après confirmation de la disponibilité du déménageur et la signature de votre contrat avec Nextories.</li>
            <li>Les 3 paiements suivants seront automatiquement prélevés chaque mois, à date fixe, sur la même carte bancaire.</li>
            <li>Aucun document supplémentaire n'est requis pour les paiements jusqu'à 6 000 €.</li>
          </ul>
          <p>Le financement est géré par notre partenaire Floa.<br>Les échéances seront prélevées automatiquement selon l'échéancier validé.</p>
          <br><p class="u-font-size-tiny">En cliquant sur "Valider", vous acceptez que vos données personnelles soient transmises et traitées par Floa dans le cadre de votre demande de paiement en plusieurs fois. <a class="link" href="https://www.floabank.fr/politique-confidentialite" target="_blank">Plus d'informations.</a></p><p class="u-font-size-tiny">En cliquant sur "Valider", vous avez pris connaissance et acceptez les conditions générales du paiement en plusieurs fois de Floa. <a class="link" href="https://www.floabank.fr/conditions-generales-paiement-plusieurs-fois" target="_blank">Voir ici</a></p>`,
          contentIndividualWithFloaAlreadyPaid: `
          <p><b>Vous êtes engagé avec Floa concernant le financement et le paiement de votre déménagement</b></p>
          <p>À ce stade, aucun nouveau paiement ne vous est demandé et votre financement reste actif.</p>
          <p>En cas de modification du prix initial, une facture ou un avoir sera disponible dans votre espace client.</p>
          <ul>
            <li>En cas de surplus, une page de paiement par carte bancaire ou virement sera proposée (hors Floa).</li>
            <li>En cas de montant inférieur, un avoir sera appliqué sur la dernière échéance.</li>
          </ul>`,
        },
        loading: {
          loadingText: 'Redirection vers le site de Floa en cours',
          subtitle: 'Paiement en 4 X par carte bancaire',
        },
      },
      bankTransfer: {
        options: {
          title: 'Virement bancaire',
          contentIndividualWithArrhes: `Aucun virement ne vous est demandé à cette étape.<br><br>Vous effectuerez votre virement uniquement après confirmation de la disponibilité du déménageur et signature de votre contrat.<br><br>Le paiement de votre déménagement s’effectue en 2 étapes :<ul><li>Les arrhes, réglées lors de la signature de votre contrat (représentant 30 % du montant total)</li><li>Le solde, réglé une fois votre déménagement effectué</li></ul>Pensez à indiquer la référence de votre dossier lors du virement afin de permettre son identification.`,
          contentIndividualWithArrhesAlreadyPaid: '@:payment.preBooking.paymentTypes.creditCard.options.contentIndividualWithArrhesAlreadyPaid',
        },
      },
    },
  },
  booking: {
    subtitleBankTransfer: '✅ Paiement confirmé',
    totalPrice: {
      title: '<div><p>Montant total</p></div><div class="--item__after"><span>{price} {exclTax}</span></div>',
      arrhesAmountIndividualWithArrhes: '<div><p><b>Les arrhes ({arrhesPercent} %)</b></p></div><div class="--item__after"><span><b>{arrhesAmount} {exclTax}</b></span><i>À régler maintenant pour valider</i></div>',
      arrhesAmountIndividualWithArrhesAlreadyPaid: '<div><p><b>Arrhes déjà réglés</b></p></div><div class="--item__after"><span><b>{arrhesAmount} {exclTax}</b></span></div>',
      arrhesAmountDisabledPayment: '<div><p><b>Les arrhes ({arrhesPercent} %)</b></p></div><div class="--item__after"><span><b>{arrhesAmount} {exclTax}</b></span></div>',
      arrhesAmountIndividualPaid: '<div><p><b>Les arrhes ({arrhesPercent} %)</b></p></div><div class="--item__after"><span><b>{arrhesAmount} {exclTax}</b></span><i>déjà réglés</i></div>',
      solde: '<div><p>Le solde</p></div><div class="--item__after"><span>{solde} {exclTax}</span><i>à régler suite à votre déménagement</i></div>',
      soldeIndividualWithArrhes: '<div><p>Le solde</p></div><div class="--item__after"><span>{solde} {exclTax}</span><i>À la réalisation du déménagement</i></div>',
      soldeIndividualWithArrhesAlreadyPaid: '<div><p><b>Reste à régler après votre déménagement</b></p></div><div class="--item__after"><span><b>{solde} {exclTax}</b></span><i class="--max-width">à régler suite à votre déménagement</i></div>',
    },
    book: 'Signer',
    bookMinarm: 'Suivant',
    bookIndividual: 'Valider & Signer',
    bookIndividualWithArrhes: 'Payer & Signer',
    bookIndividualArrhesPaid: 'Signer',
    bookIndividualWithArrhesAlreadyPaid: 'Continuer',
    bookBankTransfer: 'Signer',
    loadingSubtitle: '',
    contentIndividualWithArrhes: '<b>Vous êtes sur le point d’effectuer la réservation de cette offre.</b><br>En validant cette étape, nous procéderons au règlement de {arrhesPercent} % du montant {exclTax}, soit <b>{arrhesAmount} {exclTax}</b> sur votre carte bancaire.',
    contentIndividualArrhesPaid: 'Vous êtes sur le point d’effectuer la réservation de cette offre.<br><br>Nous vous confirmons que <b>nous avons déjà reçu votre règlement des arrhes, d\'un montant de {arrhesAmount} {exclTax}</b> et nous vous en remercions. Rien ne vous sera donc prélevé à ce stade.',
    contentIndividualWithArrhesAlreadyPaid: 'Vous avez déjà réglé <b>{arrhesAmount}</b> lors de votre première réservation. <b>Aucun nouveau paiement n’est nécessaire aujourd’hui.</b>',
    contentBankTransfer: {
      default: '<b>Vous êtes sur le point de valider votre pré-réservation.</b><br>Un virement de 30% du montant TTC, soit <b>{arrhesAmount} {exclTax}</b>, est requis pour finaliser votre réservation et accéder à la signature de votre contrat.',
      defaultIndividualWithArrhesAlreadyPaid: '<b>Votre virement a bien été reçu.</b><br>Vous pouvez maintenant signer votre contrat afin de finaliser votre réservation.',
      notFirstBooking: '@:payment.booking.contentIndividualWithArrhesAlreadyPaid',
    },
    footerCardContentIndividualWithArrhes: 'Dans le cadre d’un déménagement, les arrhes représentent une somme que vous payez pour confirmer votre réservation. Cette somme sera déduite du solde total de votre déménagement.',
    footerCardContentIndividualWithArrhesAlreadyPaid: 'Les arrhes déjà versés ont été automatiquement rattachés à cette nouvelle réservation. Ils seront déduits du montant total de votre déménagement. Le solde sera prélevé après votre déménagement.',
    footerCardContentBankTransfer: {
      default: '<b>Vous pourrez signer votre contrat dès réception de votre virement.</b><br>👉 Le bouton de signature sera automatiquement disponible une fois le paiement reçu.<br>Pensez à indiquer la référence de votre dossier lors du virement.',
      defaultIndividualWithArrhesAlreadyPaid: '@:payment.booking.footerCardContentIndividualWithArrhes',
      individualWithArrhesAlreadyPaid: '<b>Votre virement a bien été reçu.</b><br>Vous pouvez maintenant signer votre contrat afin de finaliser votre réservation.',
      notFirstBooking: '@:payment.booking.footerCardContentIndividualWithArrhesAlreadyPaid',
    },
  },
  card: {
    subtitle: 'J\'autorise le paiement sécurisé de {price} {exclTax}',
    subtitleLegend: '3DSecure',
    prebook: {
      title: 'Votre moyen de règlement',
      content: '<b>Entrez votre carte bancaire maintenant, payez plus tard</b> : vous ne serez débité qu\'une fois le contrat signé.',
      contentIndividualWithArrhes: '<b>Entrez votre carte bancaire maintenant, payez plus tard</b> : vous ne serez débité qu\'une fois le contrat signé.<br><br><u>A propos de votre paiement :</u><br> Le paiement de votre déménagement s\'effectue en 2 étapes : <ul><li>{arrhesPercent} % à la signature de votre contrat (représentant le règlement des arrhes).</li><li>puis le solde vous sera débité une fois votre déménagement effectué.</li></ul>',
    },
    book: {
      title: 'Votre moyen de règlement',
      titleIndividual: 'Votre moyen de règlement',
      titleIndividualWithArrhes: 'Règlement des arrhes',
      contentIndividual: '<b>Entrez votre carte bancaire maintenant, payez plus tard</b> : vous ne serez débité qu\'une fois le contrat signé.',
      contentIndividualWithArrhes: 'Pour finaliser votre réservation, nous allons prélever sur votre carte bancaire le montant des arrhes ({arrhesPercent} % du montant total, soit {arrhesAmount}).',
      content: '<p class=\'u-color-warning\'><b>Vous avez un reste à charge de {priceDiff} {exclTax}.</b></p><p><b>Veuillez renseigner vos coordonnées bancaires ci dessous afin de réserver votre déménagement.</b><br>Vous ne serez débité qu\'une fois le déménagement réalisé uniquement, le dépassement exact sera recalculé en fonction des montants définitifs de la facture du déménagement et du plafond de prise en charge.</p>',
      contentMinarm: '<p class=\'u-color-warning\'><b>Le plafond validé à ce jour par @:base.minarm_organism_le induit un reste à charge de {priceDiff} {exclTax}.</b></p><p><b>Veuillez renseigner vos coordonnées bancaires ci-dessous afin de réserver votre déménagement.</b><br>Vous ne serez débité qu\'une fois le déménagement réalisé uniquement, le dépassement exact sera recalculé en fonction des montants définitifs de la facture du déménagement et du plafond de prise en charge.</p>',
    },
  },
  form: {
    labelChooseByDefault: 'Choisir ce moyen de paiement par défaut',
    add: 'Ajouter',
  },
  actions: {
    book: 'Valider',
    prebook: 'Valider',
  },
  creditCard: {
    title: 'Votre moyen de règlement',
    amountWarningText: '<i>NB: Veuillez vérifier que les plafonds de votre carte bancaire vous permettent de régler ce montant.</i>',
    amountWarningTextIndividual: '<i><u>Astuce</u> : Veillez à ce que les plafonds de paiement de votre carte bancaire vous permettent de régler votre déménagement.</i>',
    individual: {
      title: 'Votre moyen de règlement',
      firstText: '<b>Entrez votre carte bancaire maintenant, payez plus tard</b> : vous ne serez débité qu\'une fois le contrat signé.',
      firstTextNoArrhes: '<b>Entrez votre carte bancaire maintenant, payez plus tard</b> : vous ne serez débité qu\'une fois le déménagement réalisé.',
      paymentDetails: '<u>A propos de votre paiement :</u><br> Le paiement de votre déménagement s\'effectue en 2 étapes : <ul><li>{arrhesPercent} % à la signature de votre contrat (représentant le règlement des arrhes).</li><li>puis le solde vous sera débité une fois votre déménagement effectué.</li></ul>',
    },
    pcd: {
      title: 'Votre moyen de règlement',
      firstText: 'Vous ne serez débité qu\'une fois le déménagement réalisé uniquement, le dépassement exact sera recalculé en fonction des montants définitifs de la facture du déménagement et du plafond.',
    },
  },
  creditCardPayment: {
    title: 'Carte bancaire',
    toggle: 'Ajouter une carte bancaire',
    addCard: 'Enregistrer la carte et valider',
    addOtherCard: 'Enregistrer une nouvelle carte',
  },
  security: {
    content: '<b>Paiement SSL sécurisé</b><br>Vous pouvez remplir le formulaire en toute confiance',
    logo: [
      {
        name: 'verified-by-visa',
        image: verifiedByVisa,
      },
      {
        name: 'master-card-secure-code',
        image: masterCardSecureCode,
      },
      {
        name: 'american-express-safe-key',
        image: americanExpressSafeKey,
      },
    ],
  },
  listCardsPayment: {
    cb: {
      name: 'carte-bleue',
      image: cb,
    },
    visa: {
      name: 'visa',
      image: visa,
    },
    masterCard: {
      name: 'master-card',
      image: masterCard,
    },
    amex: {
      name: 'american-express',
      image: americanExpress,
    },
  },
  installment: {
    name: 'floa',
    image: floa,
  },
  bankTransfer: {
    name: 'sepa',
    image: sepa,
  },
  type: {
    content: 'EFFECTUEZ VOTRE PAIEMENT <b>EN TOUTE SÉCURITÉ</b><br>Choisissez votre moyen de paiement :',
    title: 'Moyens de paiement',
    methods: [
      {
        name: '@:payment.listCardsPayment.visa.name',
        image: '@:payment.listCardsPayment.visa.image',
      },
      {
        name: '@:payment.listCardsPayment.masterCard.name',
        image: '@:payment.listCardsPayment.masterCard.image',
      },
      {
        name: '@:payment.listCardsPayment.cb.name',
        image: '@:payment.listCardsPayment.cb.image',
      },
      {
        name: 'paypal',
        image: paypal,
      },
    ],
  },
  authorization: {
    title: '@:payment.creditCardPayment.title',
    panelText: 'Le paiement par carte bancaire est le moyen le plus rapide pour régler votre montant.<br><br>Une fois le paiement effectué, votre règlement est immédiatement pris en compte.<br><br>Vous pouvez utiliser une carte déjà enregistrée ou en ajouter une nouvelle en toute sécurité.<br><br>Toutes les transactions sont sécurisées afin de garantir la confidentialité de vos informations.',
    button: 'Payer',
    confirmation: 'Votre paiement par carte bancaire a bien été pris en compte.',
  },
  wireTransfer: {
    title: 'Virement bancaire',
    button: 'J\'ai éffectué le virement',
    confirmation: 'Vous avez indiqué avoir réalisé le virement et nous vous en remercions. La vérification de la bonne réception de votre virement est en cours.',
    panelText: `Effectuez votre virement en utilisant les coordonnées bancaires ci-dessous.<br><br>Pensez à indiquer la référence {paymentRef} afin que votre paiement soit correctement identifié.<br><br>Votre règlement sera pris en compte dès réception des fonds, ce qui peut prendre quelques jours selon votre banque.<br><br>Pour un traitement plus rapide, vous pouvez effectuer un virement instantané si votre banque le propose.`,
  },
  subtitleConfirmationPayment: {
    creditCard: 'Paiement confirmé',
    bankTransfer: 'Confirmation',
  },
  nextConfirmationPayment: 'Retour au comparateur',
  loadingText: 'Réservation de votre déménagement en cours...',
  loadingTextB2BWithPlafond: 'Enregistrement de votre CB en cours...',
};
